import { RECEIVE_ACCOUNT_SUMMARY } from '../../constants/index';

export const RATING_UPDATED = 'maryMagicSurvey/RATING_UPDATED';
export const REVIEW_SUBMITTED = 'maryMagicSurvey/REVIEW_SUBMITTED';
export const SUBMISSION_RESPONSE_RECEIVED = 'maryMagicSurvey/SUBMISSION_RESPONSE_RECEIVED';
export const THANKS_FOR_FEEDBACK = 'maryMagicSurvey/THANKS_FOR_FEEDBACK';
export const CLEAR_MARY_MAGIC_FORM = 'maryMagicSurvey/CLEAR_MARY_MAGIC_FORM';
export const HAS_SUBMITTED = 'maryMagicSurvey/HAS_SUBMITTED';
export const ADD_SOURCE = 'maryMagicSurvey/ADD_SOURCE';

export const starRatingUpdated = ({ value, genre }: any) => ({
  type: RATING_UPDATED,
  payload: { value, genre },
});

export const reviewSubmitted = (value: any) => ({
  type: REVIEW_SUBMITTED,
  payload: { value },
});

export const responseReceived = (value: any) => ({
  type: SUBMISSION_RESPONSE_RECEIVED,
  payload: { value },
});

export const thanksForFeedback = () => ({
  type: THANKS_FOR_FEEDBACK,
});

export const clearMaryMagicSurvey = () => ({
  type: CLEAR_MARY_MAGIC_FORM,
});

export const hasSubmitted = (value: any) => ({
  type: HAS_SUBMITTED,
  payload: { value },
});

export const addSource = (value: any) => ({
  type: ADD_SOURCE,
  payload: { value },
});

export default (state = {}, action: any) => {
  switch (action.type) {
    case RATING_UPDATED:
      return {
        ...state,
        [action.payload.genre]: action.payload.value,
      };
    case REVIEW_SUBMITTED:
      return {
        ...state,
        submissionStatus: 'submitting',
      };
    case SUBMISSION_RESPONSE_RECEIVED:
      return {
        ...state,
        submissionStatus: action.payload.value,
      };
    case THANKS_FOR_FEEDBACK:
      return {
        ...state,
        thanksForFeedback: true,
      };
    case RECEIVE_ACCOUNT_SUMMARY:
      return {
        ...state,
        accountId: action.payload.value.id,
        hasSubmittedMaryMagicSurvey: action.payload.value.submitted_mary_magic_form,
        market: action.payload.value.market,
      };
    case CLEAR_MARY_MAGIC_FORM:
      return {
        // @ts-expect-error ts-migrate(2339) FIXME: Property 'accountId' does not exist on type '{}'.
        accountId: state.accountId,
        // @ts-expect-error ts-migrate(2339) FIXME: Property 'hasSubmittedMaryMagicSurvey' does not ex... Remove this comment to see the full error message
        hasSubmittedMaryMagicSurvey: state.hasSubmittedMaryMagicSurvey,
        // @ts-expect-error ts-migrate(2339) FIXME: Property 'market' does not exist on type '{}'.
        market: state.market,
      };
    case HAS_SUBMITTED:
      return {
        ...state,
        hasSubmittedMaryMagicSurvey: action.payload.value,
      };
    case ADD_SOURCE:
      return {
        ...state,
        source: action.payload.value,
      };
    default:
      return state;
  }
};
